import { Address, Contact } from '~api/address_book';

export const createContactFromAddress = (
  prefix: string,
  name: string,
  address?: Address,
  phone?: string,
  email?: string
): Contact | undefined => {
  if (!address) {
    return undefined;
  }

  return {
    id: `${prefix}_${name}_${new Date().getTime()}`,
    email,
    phone,
    address,
  };
};
